import { useMemo } from "react";

import { getNoteColorConfig } from "~/utils/components";
import { DEFAULT_NOTE_COLOR } from "~/constants";

import { Truncate } from "../truncate/Truncate";

import type { NoteColor } from "../noteCard/NoteCard";

export interface WatchViewDockedNoteProps {
  color?: NoteColor;
  placeholder?: string;
  value?: string;
  onClick?: () => void;
}

export function WatchViewDockedNote({
  color = DEFAULT_NOTE_COLOR,
  placeholder,
  value,
  onClick,
}: WatchViewDockedNoteProps) {
  const customProperties = useMemo(() => {
    const { background, text } = getNoteColorConfig(color);
    return {
      "--watchview-note-color": background,
      "--watchview-note-text-color": text,
    };
  }, [color]);

  return (
    <button
      className="WatchViewDockedNote"
      style={customProperties}
      onClick={onClick}
    >
      <span className="WatchViewDockedNote__placeholder">
        <Truncate>{value || placeholder}</Truncate>
      </span>
    </button>
  );
}
